var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg054Medium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_054-medium",
    "data-name": "054-medium",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.316,
    height: 24,
    viewBox: "0 0 30.316 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67394",
    "data-name": "Group 67394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67393",
    "data-name": "Group 67393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80458",
    "data-name": "Path 80458",
    d: "M27.9,56.154l2.419-2.314v-.507h-8.38L15.964,68.2,9.169,53.333H.383v.507l2.826,3.4a1.186,1.186,0,0,1,.383.989V71.6a1.524,1.524,0,0,1-.408,1.326L0,76.783v.5H9.025v-.507L5.842,72.925A1.571,1.571,0,0,1,5.4,71.6V60.036l7.923,17.253h.921l6.812-17.253V73.78c0,.363,0,.437-.237.675l-2.451,2.371v.508H30.26v-.507L27.9,74.514a.7.7,0,0,1-.27-.675V56.828a.7.7,0,0,1,.269-.675Z",
    transform: "translate(0 -53.333)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg054Medium);
export default __webpack_public_path__ + "static/media/054-medium.8876df846527e649f9bf2a325efe6bcb.svg";
export { ForwardRef as ReactComponent };